module.exports = __webpack_public_path__ + "img/nis.129ff306.png";